import { render, staticRenderFns } from "./reviewReturnTipsDialog.vue?vue&type=template&id=3faefdd4&scoped=true&"
import script from "./reviewReturnTipsDialog.vue?vue&type=script&lang=js&"
export * from "./reviewReturnTipsDialog.vue?vue&type=script&lang=js&"
import style0 from "./reviewReturnTipsDialog.vue?vue&type=style&index=0&id=3faefdd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faefdd4",
  null
  
)

export default component.exports